import Precarga from './precarga';
export default Precarga;